import { t } from "@lingui/macro";
import { z } from "zod";

export const configureValidation = (locale: string) => {
  z.setErrorMap((issue, context) => {
    if (!locale.startsWith("fr")) return { message: context.defaultError };

    switch (issue.code) {
      case "invalid_type":
        return {
          message:
            issue.received === "undefined"
              ? t`Ce champ est requis.`
              : t`Cette valeur n’est pas valide.`,
        };
      case "invalid_string":
        return {
          message:
            issue.validation === "email"
              ? t`Saisissez une adresse e-mail valide.`
              : issue.validation === "url"
                ? t`Saisissez une adresse web valide.`
                : t`Le format de cette valeur n’est pas valide.`,
        };
      case "too_small": {
        const minimum = String(issue.minimum);
        if (issue.type === "string")
          return { message: t`Saisissez au moins ${minimum} caractères.` };
        if (issue.type === "array")
          return { message: t`Sélectionnez au moins ${minimum} éléments.` };
        return { message: t`La valeur doit être supérieure ou égale à ${minimum}.` };
      }
      case "too_big": {
        const maximum = String(issue.maximum);
        if (issue.type === "string")
          return { message: t`Saisissez au maximum ${maximum} caractères.` };
        if (issue.type === "array")
          return { message: t`Sélectionnez au maximum ${maximum} éléments.` };
        return { message: t`La valeur doit être inférieure ou égale à ${maximum}.` };
      }
      case "invalid_date":
        return { message: t`Saisissez une date valide.` };
      default:
        return { message: t`Cette valeur n’est pas valide.` };
    }
  });
};
